import { render, staticRenderFns } from "./Concept.vue?vue&type=template&id=1fdbc198&scoped=true&"
import script from "./Concept.vue?vue&type=script&lang=js&"
export * from "./Concept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdbc198",
  null
  
)

export default component.exports